import { createRouter, createWebHistory } from 'vue-router';
import VoucherWizard from "../components/VoucherWizard.vue";
import NotFound from '../pages/NotFound.vue'
import VoucherSuccess from '../pages/VoucherSuccess.vue'


const routes = [

  {
    path: '/:storeId/:voucherNo/success', // Capture storeId directly from the root path
    name: 'VoucherSuccess',
    component: VoucherSuccess,
  },
  {
    path: '/:storeId', // Capture storeId directly from the root path
    name: 'Store',
    component: VoucherWizard,
  },
  // Redirect from root to a default storeId
  {
    path: '/', // Explicitly handle root path
    name: 'NotFound',
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;